//#region src/schema/helpers/is-on-schema-target-path.ts
var e = (e, t) => !!(e && t && (t === e || t.startsWith(`${e}.`)));
//#endregion
export { e as isOnSchemaTargetPath };

//# sourceMappingURL=is-on-schema-target-path.js.map